import React from 'react';
import { Router } from 'react-router-dom';

import { history } from '../history';

import { OverviewRoutes } from './overviewRoutes';

export const Routing: React.FC = ({ children }) => (
    <Router history={history}>
        <OverviewRoutes>{children}</OverviewRoutes>
    </Router>
);
